<template>
  <div class="aboutus">
    <mynav></mynav>
    <div class="index-top">
      <img src="../assets/aboutTop.png" alt="" width="100%" />
      <div class="banner-text" style="text-align: center">
        <h1>碰撞科技</h1>
        <p>碰撞科技成立于2014年12月，是一家高新技术和双软科技企业。</p>
        <p>
          是国内领先的智慧城市整体解决方案提供商。采用5G，物联网、大数据治理、元宇宙、区块链、数字孪生等新技术运用
          于城市数字化转型业务场景中。
        </p>
      </div>
    </div>
    <div class="general">
      <div class="general-content aboutTop-content">
        <div class="aboutTop-content-left">
          <img src="../assets/about.png" alt="" />
        </div>
        <div class="aboutTop-content-right">
          <div>
            <!-- <div>”</div> -->
            <h2>备受认可的技术实力</h2>
            <p>
              碰撞信息业务领域涵盖智慧文旅、智慧农业、智慧政务、智慧政务、智慧园区、应急管理、智慧社区、健康管理和智慧城市公共平台的建设与运营。其中，智慧文旅、智慧农业、
              智慧政务等业务服务全国五百万人口。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutBottom">
      <div class="aboutBottom-item">
        <img src="../assets/about-1.png" alt="" />
        <div class="aboutBottom-item-text">
          <div>使命</div>
          <div>人工智能造福大众</div>
        </div>
      </div>
      <div class="aboutBottom-item">
        <img src="../assets/about-2.png" alt="" />
        <div class="aboutBottom-item-text">
          <div>愿景</div>
          <div>让数学转型更容易</div>
        </div>
      </div>
      <div class="aboutBottom-item">
        <img src="../assets/about-3.png" alt="" />
        <div class="aboutBottom-item-text">
          <div>价值观</div>
          <div>技术信仰 价值务实</div>
        </div>
      </div>
    </div>
    <div class="general">
      <div class="general-content us">
        <div class="us-title">联系我们</div>
        <p class="us-p">地址：上海市杨浦区逸仙路25号，同济晶度大厦18层</p>
        <p class="us-p">商务合作：business@pengzhuang.net</p>
      </div>
    </div>
    <!-- <myfooter :type="1"></myfooter> -->
  </div>
</template>
<script>
// import myfooter from "../components/myfooter.vue";
import mynav from "../components/mynav.vue";
export default {
  data() {
    return {};
  },
  components: {
    // myfooter,
    mynav,
  },
};
</script>
<style lang="less" scoped>
img {
  display: block;
}
.aboutus {
  .aboutTop-content {
    display: flex;
    margin-bottom: 40px;
    .aboutTop-content-left {
      width: 50%;
      img {
        width: 100%;
      }
    }
    .aboutTop-content-right {
      width: 50%;
      background-color: rgb(33, 41, 62);
      color: #fff;
      padding: 0 58px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      h2 {
        margin-bottom: 10px;
      }
      p {
        line-height: 24px;
        font-size: 14px;
      }
    }
  }
  .aboutBottom {
    width: 100%;
    margin: 0 auto;
    display: flex;
    max-width: 1440px;
    .aboutBottom-item {
      width: 33.33%;
      position: relative;
      img {
        width: 100%;
      }
      .aboutBottom-item-text {
        background-color: rgba(255, 255, 255, 0.3);
        padding: 30px 0;
        width: 62%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
        text-align: center;
        line-height: 30px;
        font-size: 20px;
      }
    }
  }
  .us {
    padding-bottom: 180px;
  }
  .us-title {
    color: rgb(33, 41, 62);
    font-size: 40px;
    font-weight: 700;
    line-height: 71px;
    width: 371px;
    border-bottom: 1px solid rgb(0, 0, 0);
    margin-bottom: 20px;
  }
  .us-p {
    color: rgb(33, 41, 62);
    font-size: 24px;
    font-weight: 700;
    line-height: 40px;
  }
}
@media screen and (max-width: 992px) {
  .aboutus {
    .aboutTop-content {
      margin-bottom: 20px;
      .aboutTop-content-left {
      }
      .aboutTop-content-right {
        padding: 0 30px;
      }
    }
    .aboutBottom {
      .aboutBottom-item {
        img {
        }
        .aboutBottom-item-text {
          padding: 10px 0;
          width: 62%;
          line-height: 25px;
          font-size: 18px;
        }
      }
    }
    .us {
      padding-bottom: 140px;
    }
    .us-title {
      font-size: 30px;
      line-height: 50px;
      width: 300px;
    }
    .us-p {
      font-size: 20px;
      line-height: 30px;
    }
  }
}
@media screen and (max-width: 768px) {
  .aboutus {
    .aboutTop-content {
      .aboutTop-content-left {
        display: none;
      }
      .aboutTop-content-right {
        width: 100%;
        padding: 40px 20px;
        box-sizing: border-box;
        margin: 0 auto;
      }
    }
    .aboutBottom {
      .aboutBottom-item {
        img {
        }
        .aboutBottom-item-text {
          padding: 7px 0;
          width: 70%;
          line-height: 25px;
          font-size: 8px;
        }
      }
    }
    .us {
      padding-bottom: 100px;
    }
    .us-title {
      font-size: 20px;
      line-height: 50px;
      width: 200px;
    }
    .us-p {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>